import { apiUrl, authHeaders } from './auth';

export interface ContactAttempt {
  id?: number;
  campaign_request: number;
  attempt_datetime: string;
  method: 'call' | 'email' | 'both';
  method_display?: string;
  note: string;
  person: number;
  person_name?: string;
}

export interface ContactAttemptCreate {
  campaign_request: number;
  attempt_datetime: string;
  method: 'call' | 'email' | 'both';
  note: string;
  person: number;
}

export interface ContactAttemptStats {
  total_attempts: number;
  call_attempts: number;
  email_attempts: number;
  latest_attempt: ContactAttempt | null;
}

export const fetchContactAttempts = async (campaignRequestId: number): Promise<ContactAttempt[]> => {
  const headers = authHeaders();
  // The endpoint pages at 20 by default; ask for all of them so a long-running
  // request's history isn't cut short.
  const url = `${apiUrl}/v2/contact-attempts/?campaign_request_id=${campaignRequestId}&pageSize=1000`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  if (!response.ok) {
    throw new Error('Failed to fetch contact attempts');
  }
  const json = await response.json();
  return json.results || json; // Handle both paginated and direct array responses
};

export const createContactAttempt = async (contactAttempt: ContactAttemptCreate): Promise<ContactAttempt> => {
  const headers = authHeaders();
  const url = `${apiUrl}/v2/contact-attempts/`;
  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(contactAttempt),
  });
  if (!response.ok) {
    throw new Error('Failed to create contact attempt');
  }
  return await response.json();
};

export const fetchContactAttemptStats = async (campaignRequestId: number): Promise<ContactAttemptStats> => {
  const headers = authHeaders();
  const url = `${apiUrl}/v2/contact-attempts/stats/?campaign_request_id=${campaignRequestId}`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  if (!response.ok) {
    throw new Error('Failed to fetch contact attempt stats');
  }
  return await response.json();
};

export const updateContactAttempt = async (id: number, contactAttempt: Partial<ContactAttemptCreate>): Promise<ContactAttempt> => {
  const headers = authHeaders();
  const url = `${apiUrl}/v2/contact-attempts/${id}/`;
  const response = await fetch(url, {
    method: 'PATCH',
    headers,
    body: JSON.stringify(contactAttempt),
  });
  if (!response.ok) {
    throw new Error('Failed to update contact attempt');
  }
  return await response.json();
};

export const deleteContactAttempt = async (id: number): Promise<void> => {
  const headers = authHeaders();
  const url = `${apiUrl}/v2/contact-attempts/${id}/`;
  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  });
  if (!response.ok) {
    throw new Error('Failed to delete contact attempt');
  }
};
